import moment from "moment";

export const PREFERRED_DATETIME_FORMAT = "MM/DD/YYYY hh:mm A";

export const formatDateTime = i => {
  return i
    ? moment
        .utc(i)
        .local()
        .format(PREFERRED_DATETIME_FORMAT)
    : "-";
};
